import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import Button from 'core/ui/Button';

import { getColor, TrackUtil } from 'core/utils';
import Envelope from 'core/icons/Envelope';

const padding = (size) => {
	if (size === 'sm') return '0 16px';
	return size === 'md' ? '8px' : '12px 24px';
};

const height = (size) => {
	if (size === 'sm') return '34px';
	return size === 'md' ? '40px' : '48px';
};

const marginTop = (size) => {
	if (size === 'sm') return '0';
	return '8px';
};

const ContactButton = styled(Button)`
	background: ${getColor("primaryBrand")};
	color: ${getColor("white")};
	font-weight: 600;
	font-size: ${props => props.bigText ? '19px' : '13px'};
	outline: none;
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
	padding: ${props => padding(props.btnSize)};
	line-height: 1;
	height: ${props => height(props.btnSize)};
	margin-top: ${props => marginTop(props.btnSize)};
	transition: all ease 0.3s;
	display: flex;
	width: ${props => props.fullWidth ? '100%' : 'auto'};
	align-items: center;
	justify-content: center;

	&:hover, &:focus {
		background: ${getColor("primaryBrandHover")};
	}
`;

const Icon = styled.div`
	font-size: 18px;
	margin-right: 12px;
	color: ${getColor("white")};
`;

const ContactSellerButton = ({
	className = '',
	label = 'Contact Seller',
	notLoggedLabel = 'Sign in to contact the seller',
	contactIcon,
	size = 'lg',
	element = 'button',
	isLoggedIn,
	triggerLogin,
	openModal = () => null,
	fullWidth,
	bigText,
}) => {

	const handleTriggerLogin = () => {
		TrackUtil.trackEvent('login_prompt', {
			statjoy: [{
				step_name: 'contact_seller',
			}]
		});
		triggerLogin('contact_seller', 'contact-seller');
		return;
	};

	const handleClick = (e) => {
		e.preventDefault();
		if (!isLoggedIn) {
			handleTriggerLogin();
		}
		openModal(true);
	};

	const buttonText = isLoggedIn ? label : notLoggedLabel;

	return (
		<Fragment>
			{element === 'link' ? (
				<a
					href="#"
					className={classNames(className)}
					onClick={handleClick}>
					{buttonText}
				</a>
			) : (
				<ContactButton
					fullWidth={fullWidth}
					themeType={'neutral'}
					btnSize={size}
					bigText={bigText}
					onClick={handleClick}
					className={classNames(className)}>
					{contactIcon &&
								<Icon>
									<Envelope fill={'currentColor'} />
								</Icon>
					}
					<span>{buttonText}</span>
				</ContactButton>
			)}
		</Fragment>
	);
};

ContactSellerButton.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	notLoggedLabel: PropTypes.string,
	contactIcon: PropTypes.string,
	size: PropTypes.oneOf(['sm', 'md', 'lg']),
	element: PropTypes.oneOf(['link', 'button']),
	isLoggedIn: PropTypes.bool,
	triggerLogin: PropTypes.func.isRequired,
	openModal: PropTypes.func.isRequired,
	fullWidth: PropTypes.bool,
	bigText: PropTypes.bool,
};

export default ContactSellerButton;
